<template>
  <div class="container">
    <div class="title">
      <span>关联审批信息</span>
    </div>
    <div class="center">
      <a-select  allowClear  placeholder="请选择审批单类型"  v-model="allform.approvalId"  @change="getUserInforEvent"
       style="width: 300px; margin-right: 10px; " show-search :filter-option="filterOption" >
         <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
           {{ item.name }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="showAuditCode" :disabled="allform.approvalId == undefined"> 查询审批单 </a-button>
      <a-button type="primary" @click="showPurchase"> 查询采购单 </a-button>
    </div>
    <div class="centerBottom">
      <div class="top">
          <a-table :data-source="approvalData" bordered :pagination="false">
            <a-table-column  key="applyCode" title="申请单号"  data-index="applyCode" />
            <a-table-column key="processName" title="申请标题"  data-index="processName"/>
            <a-table-column key="applyer" title="申请人"  data-index="applyer"/>
            <a-table-column key="applyerTime" title="申请时间"  data-index="applyerTime"/>
            <a-table-column key="applyerTime" title="审批结果"  data-index="applyerTime">
              <template scope="text">
                   <a-tag :color="result_apply[text].color">
                    {{ result_apply[text].txt }}
                   </a-tag>
               </template>
            </a-table-column>
             <a-table-column title="操作" >
                <template slot-scope="text, record, index">
                  <a @click="approvalDelete(record, index)">取消关联</a>
                </template>
            </a-table-column>
        </a-table>
      </div>
      <div class="bottom">
          <a-table :data-source="purchaseData" bordered :pagination="false">
            <a-table-column  key="applyCode" title="申请单号"  data-index="applyCode" />
            <a-table-column key="name" title="物品名称"  data-index="name"/>
            <a-table-column key="model" title="规格型号"  data-index="model"/>
            <a-table-column key="amount" title="数量"  data-index="amount"/>
            <a-table-column key="unit" title="单位"  data-index="unit"/>
            <a-table-column key="ascriptionDeptName" title="申购单位"  data-index="ascriptionDeptName" />
            <a-table-column key="result" title="审批结果"  data-index="result">
                <template scope="text">
                   <a-tag :color="result_apply[text].color">
                    {{ result_apply[text].txt }}
                   </a-tag>
               </template>
            </a-table-column>
             <a-table-column key="name" title="操作"  data-index="name">
                <template slot-scope="text, record, index">
                   <a @click="purchaseDelete(record, index)">取消关联</a>
                </template>
            </a-table-column>
        </a-table>

      </div>

    </div>
    <selectAuditCode :kind="kind" ref="selectAuditCode" :approvalId="approvalId"
      :data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 }"
      @applyData="getAppCode"
      @applyData2="getAppCode"
      @applyData3="getAppCode"
      @applyData4="getAppCode"
    />
  </div>
</template>

<script>
import selectAuditCode from '@/components/module/selectAuditCode.vue'
import { audit_list } from '@/api/financial'
export default {
  components: {
    selectAuditCode,
    },
  data() {
    return {
      kind: undefined,
      typeIndex: undefined,
      Approvallist: [],
      typeList: [],
      approvalData: [],
      purchaseData: [],
      allform: {
        approvalId: undefined
      },
      auditCodeData: [],
      auditCodeData2: [],
      auditCodeData3: [],
      auditCodeData4: [],
    }
  },
   mounted() {
      audit_list().then((res) => {
        if (res.code == 200) {
          res.data.splice(12, 1)
          this.Approvallist = res.data
          console.log(this.Approvallist, 'this.Approvallist')
        }
      })
   },
   methods: {
    //展示审批单弹窗
    showAuditCode() {
      this.kind = 0
      this.typeIndex = 2
      this.$refs.selectAuditCode.init({
        approvalId: this.allform.approvalId,
        typeIndex: this.typeIndex,
      })
    },
    //展示采购审批单弹窗
     showPurchase() {
      this.kind = 1
      this.typeIndex = 1
      this.$refs.selectAuditCode.init({
        approvalId: 'purchase',
        typeIndex: this.typeIndex,
      })
    },
    //得到审批单列表
    getAppCode(data) {
       data.forEach(item => {
        if(item.processDefKey === "purchase"){
          item.goodsData.forEach(item1 => {
            Object.assign(item1, {
              applyCode: item.applyCode
            })
            this.purchaseData.push(item1)
          })
          
        } else {
           this.approvalData.push(item)
        }
      })
      console.log(this.approvalData, this.purchaseData, 'approvalData, this.purchaseData==============================')
    },
    //取消关联
    approvalDelete(record, index) {
      this.approvalData.splice(index, 1)

    },
    purchaseDelete(record, index) {
      this.purchaseData.splice(index, 1)

    }

   }
}
</script>

<style lang="less" scoped>
.container {
  margin-top: 10px;
  .title {
    font-weight: 700;
    margin-left: 0px;
    color: black;
  }
  .center {
    padding: 10px;
  }
  .centerBottom {
    padding: 10px;
    .bottom {
      margin-top: 20px;
    }
  }
}
</style>